// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import api from "../../utils/api.js";
import {useParams} from "react-router-dom";
import "./DatabaseEdit.css";
import DatabaseCreate from "../DatabaseCreate/DatabaseCreate.js";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout.js";


function DatabaseEdit() {
    const [name, setName] = React.useState(null)
    const [description, setDescription] = React.useState(null)
    const [hostingMode, setHostingMode] = React.useState(null)
    const [selectedOption, setSelectedOption] = React.useState(null)
    const [selectedRoleNames, setSelectedRoleNames] = React.useState([])
    const {id} = useParams()
    const returnTo = new URLSearchParams(window.location.search).get("returnTo")
    const [loading, setLoading] = React.useState(true)

    useEffect(() => {
        api.getDatabase(id).then(server => {
            setName(server.name)
            setDescription(server.description)
            setHostingMode(server.hostingMode)
            setSelectedOption(server.onSchemaChange)
            setSelectedRoleNames(server.roles.map(role => role.name))
            setLoading(false)
        })
    }, []);

    if (loading) {
        return <LoadingLayout />
    }

    return <DatabaseCreate
        returnTo={returnTo}
        databaseId={id}
        defaultName={name}
        defaultDescription={description}
        lockedInHostingMode={hostingMode}
        defaultSelectedRoleNames={selectedRoleNames}
        defaultSchemaOption={selectedOption}
        defaultPageTitle={"Database Settings"}
    />
}

export default DatabaseEdit

